<template>
    <v-dialog v-model="dialog" max-width="600" persistent>

        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title class="headline primary white--text"><v-icon color="white" class="pr-2">mdi-form-textbox-password</v-icon> Login Administrativo </v-toolbar-title>
            </v-toolbar>

            <v-form ref="form" v-model="validDialog" lazy-validation>

                <v-card-text class="mt-4">

                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Login" v-model="acesso.login" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Senha" v-model="acesso.senha" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>

                </v-card-text>

                <v-card-actions class="teste">
                    <v-spacer/>
                    <v-btn color="secundary" text @click="dialog = false">Fechar</v-btn>
                    <v-btn color="primary" @click="Salvar()" text :disabled="!validDialog" >Entrar</v-btn>
                </v-card-actions>

            </v-form>

        </v-card>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>
</template>

<script>
import AdministrativoService from '../../../core/services/AdministrativoService';

export default {
    props:{
        value: {
            required: true
        }
    },
    data: () => ({
        validDialog: false,
        dialog: false,
        showPassword: false,
        acesso: {
            login: '',
            senha: ''
        },
        service: new AdministrativoService(),
        sessionApp: {},
        loading: false,
        fieldRules: [ v => !!v || 'Campo obrigatório' ],
    }),
    watch: {
        value: function(){
            this.dialog = this.value;
        },
        dialog: function(){
            if(!this.dialog){
                this.$emit('fechou');
            }
        }
    },
    mounted() {
        this.sessionApp = JSON.parse(localStorage.sessionApp);
    },
    beforeUpdate(){
        if(!this.dialog){
            this.$emit('fechou');
        }
    },
    methods:{
        Salvar(){
            if(this.$refs.form.validate()){
                this.loading = true;
                this.service.Login(this.acesso).then(
                    res => {
                        localStorage.setItem('administrativo', JSON.stringify(res.data));
                        this.$router.push({ name: 'administrativoEmpresa' });
                    },
                    err => {
                        localStorage.removeItem('administrativo');
                        this.$swal('Aviso', err.response.data, 'error');
                    }
                ).finally(() => {
                    this.loading = false;
                    this.Close();
                })
            }
        },
        Clear(){
            this.loading = false;
            this.validDialog = true;
            this.acesso = {
                login: '',
                senha: ''
            }
        },
        Close(){
            this.Close();
            this.dialog = false;
        }
    }
}

</script>